import { useTranslation } from "react-i18next";

import List from "../../ui/list-reports/List";

export default function Reports() {
  const { t } = useTranslation();
  return (
    <div>
      <List />
    </div>
  );
}
